export const INITIAL_PROGRESS_VALUE = 0
